//BRAND
export const GET_BRAND: { [x: string]: any } = {
  LOADING: "BRAND_GET_LOADING",
  SUCCESS: "BRAND_GET_SUCCESS",
  ERROR: "BRAND_GET_ERROR",
};

export const CREATE_BRAND: { [x: string]: any } = {
  LOADING: "BRAND_CREATE_LOADING",
  SUCCESS: "BRAND_CREATE_SUCCESS",
  ERROR: "BRAND_CREATE_ERROR",
};

export const GET_BRAND_BY_ID: { [x: string]: any } = {
  LOADING: "BRAND_GET_BY_ID_LOADING",
  SUCCESS: "BRAND_GET_BY_ID_SUCCESS",
  ERROR: "BRAND_GET_BY_ID_ERROR",
};

export const UPDATE_BRAND: { [x: string]: any } = {
  LOADING: "BRAND_UPDATE_LOADING",
  SUCCESS: "BRAND_UPDATE_SUCCESS",
  ERROR: "BRAND_UPDATE_ERROR",
};

export const DELETE_BRAND: { [x: string]: any } = {
  LOADING: "BRAND_DELETE_LOADING",
  SUCCESS: "BRAND_DELETE_SUCCESS",
  ERROR: "BRAND_DELETE_ERROR",
};

//CATEGORY
export const GET_CATEGORY: { [x: string]: any } = {
  LOADING: "CATEGORY_GET_LOADING",
  SUCCESS: "CATEGORY_GET_SUCCESS",
  ERROR: "CATEGORY_GET_ERROR",
};

export const CREATE_CATEGORY: { [x: string]: any } = {
  LOADING: "CATEGORY_CREATE_LOADING",
  SUCCESS: "CATEGORY_CREATE_SUCCESS",
  ERROR: "CATEGORY_CREATE_ERROR",
};

export const UPDATE_CATEGORY: { [x: string]: any } = {
  LOADING: "CATEGORY_UPDATE_LOADING",
  SUCCESS: "CATEGORY_UPDATE_SUCCESS",
  ERROR: "CATEGORY_UPDATE_ERROR",
};

export const GET_CATEGORY_BY_ID: { [x: string]: any } = {
  LOADING: "CATEGORY_GET_BY_ID_LOADING",
  SUCCESS: "CATEGORY_GET_BY_ID_SUCCESS",
  ERROR: "CATEGORY_GET_BY_ID_ERROR",
};

export const DELETE_CATEGORY: { [x: string]: any } = {
  LOADING: "CATEGORY_DELETE_LOADING",
  SUCCESS: "CATEGORY_DELETE_SUCCESS",
  ERROR: "CATEGORY_DELETE_ERROR",
};

//CONDITION
export const GET_CONDITION: { [x: string]: any } = {
  LOADING: "CONDITION_LOADING",
  SUCCESS: "CONDITION_SUCCESS",
  ERROR: "CONDITION_ERROR",
};

export const CREATE_CONDITION: { [x: string]: any } = {
  LOADING: "CONDITION_CREATE_LOADING",
  SUCCESS: "CONDITION_CREATE_SUCCESS",
  ERROR: "CONDITION_CREATE_ERROR",
};

export const UPDATE_CONDITION: { [x: string]: any } = {
  LOADING: "CONDITION_UPDATE_LOADING",
  SUCCESS: "CONDITION_UPDATE_SUCCESS",
  ERROR: "CONDITION_UPDATE_ERROR",
};

export const DELETE_CONDITION: { [x: string]: any } = {
  LOADING: "CONDITION_DELETE_LOADING",
  SUCCESS: "CONDITION_DELETE_SUCCESS",
  ERROR: "CONDITION_DELETE_ERROR",
};

//GROUP
export const GET_GROUP: { [x: string]: any } = {
  LOADING: "GROUP_GET_LOADING",
  SUCCESS: "GROUP_GET_SUCCESS",
  ERROR: "GROUP_GET_ERROR",
};

export const GET_GROUP_BY_ID: { [x: string]: any } = {
  LOADING: "GROUP_GET_BY_ID_LOADING",
  SUCCESS: "GROUP_GET_BY_ID_SUCCESS",
  ERROR: "GROUP_GET_BY_ID_ERROR",
};

export const CREATE_GROUP: { [x: string]: any } = {
  LOADING: "GROUP_CREATE_LOADING",
  SUCCESS: "GROUP_CREATE_SUCCESS",
  ERROR: "GROUP_CREATE_ERROR",
};

export const UPDATE_GROUP: { [x: string]: any } = {
  LOADING: "GROUP_UPDATE_LOADING",
  SUCCESS: "GROUP_UPDATE_SUCCESS",
  ERROR: "GROUP_UPDATE_ERROR",
};

export const DELETE_GROUP: { [x: string]: any } = {
  LOADING: "GROUP_DELETE_LOADING",
  SUCCESS: "GROUP_DELETE_SUCCESS",
  ERROR: "GROUP_DELETE_ERROR",
};

//NAME
export const GET_NAME: { [x: string]: any } = {
  LOADING: "NAME_GET_LOADING",
  SUCCESS: "NAME_GET_SUCCESS",
  ERROR: "NAME_GET_ERROR",
};

export const GET_NAME_BY_ID: { [x: string]: any } = {
  LOADING: "NAME_GET_BY_ID_LOADING",
  SUCCESS: "NAME_GET_BY_ID_SUCCESS",
  ERROR: "NAME_GET_BY_ID_ERROR",
};

export const CREATE_NAME: { [x: string]: any } = {
  LOADING: "NAME_CREATE_LOADING",
  SUCCESS: "NAME_CREATE_SUCCESS",
  ERROR: "NAME_CREATE_ERROR",
};

export const UPDATE_NAME: { [x: string]: any } = {
  LOADING: "NAME_UPDATE_LOADING",
  SUCCESS: "NAME_UPDATE_SUCCESS",
  ERROR: "NAME_UPDATE_ERROR",
};

export const DELETE_NAME: { [x: string]: any } = {
  LOADING: "NAME_DELETE_LOADING",
  SUCCESS: "NAME_DELETE_SUCCESS",
  ERROR: "NAME_DELETE_ERROR",
};

//QUOTA
export const GET_QUOTA: { [x: string]: any } = {
  LOADING: "QUOTA_GET_LOADING",
  SUCCESS: "QUOTA_GET_SUCCESS",
  ERROR: "QUOTA_GET_ERROR",
};

export const CREATE_QUOTA: { [x: string]: any } = {
  LOADING: "QUOTA_CREATE_LOADING",
  SUCCESS: "QUOTA_CREATE_SUCCESS",
  ERROR: "QUOTA_CREATE_ERROR",
};

export const UPDATE_QUOTA: { [x: string]: any } = {
  LOADING: "QUOTA_UPDATE_LOADING",
  SUCCESS: "QUOTA_UPDATE_SUCCESS",
  ERROR: "QUOTA_UPDATE_ERROR",
};

//UNIT
export const GET_UNIT: { [x: string]: any } = {
  LOADING: "UNIT_GET_LOADING",
  SUCCESS: "UNIT_GET_SUCCESS",
  ERROR: "UNIT_GET_ERROR",
};

export const GET_UNIT_BY_ID: { [x: string]: any } = {
  LOADING: "UNIT_GET_BY_ID_LOADING",
  SUCCESS: "UNIT_GET_BY_ID_SUCCESS",
  ERROR: "UNIT_GET_BY_ID_ERROR",
};

export const CREATE_UNIT: { [x: string]: any } = {
  LOADING: "UNIT_CREATE_LOADING",
  SUCCESS: "UNIT_CREATE_SUCCESS",
  ERROR: "UNIT_CREATE_ERROR",
};

export const UPDATE_UNIT: { [x: string]: any } = {
  LOADING: "UNIT_UPDATE_LOADING",
  SUCCESS: "UNIT_UPDATE_SUCCESS",
  ERROR: "UNIT_UPDATE_ERROR",
};

export const DELETE_UNIT: { [x: string]: any } = {
  LOADING: "UNIT_DELETE_LOADING",
  SUCCESS: "UNIT_DELETE_SUCCESS",
  ERROR: "UNIT_DELETE_ERROR",
};
